module.exports = __webpack_public_path__ + "images/index/img05.880f832.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/pien/img05.jpg
// module id = 7R41
// module chunks = 21